// Meetings events template - vanilla JS (converted from jQuery)

document.addEventListener('DOMContentLoaded', function () {
    var clonedSlider = null;

    SetSelectedTab();

    // call the function to set the clear button if we have search criteria
    MeetingEventsSyncClear();

    // Tab click handler (ul.me-destination-tabs li)
    document.querySelectorAll('ul.me-destination-tabs li').forEach(function (li) {
        li.addEventListener('click', function (e) {
            e.preventDefault();

            var selectedTabLink = li.querySelector('a');
            var activeTabID = selectedTabLink && (selectedTabLink.dataset.tabId || selectedTabLink.getAttribute('data-tab-id')) ? (selectedTabLink.dataset.tabId || selectedTabLink.getAttribute('data-tab-id')) : '';
            var activeTab = '#' + activeTabID;

            // remove active on tabs list
            document.querySelectorAll('ul.me-tabs li').forEach(function (x) { x.classList.remove('active'); });
            li.classList.add('active');

            if (activeTab === '#all' || activeTabID === '' ) {
                document.querySelectorAll('.mel-destination-wrapper').forEach(function (w) { w.style.height = 'auto'; });
                document.querySelectorAll('.mel-destination').forEach(function (d) { d.classList.remove('active'); d.style.display = ''; });
                var sel = document.getElementById('selectedTab'); if (sel) sel.value = '';
            } else {
                document.querySelectorAll('.mel-destination').forEach(function (d) { d.style.display = 'none'; d.classList.remove('active'); });
                var el = document.getElementById(activeTabID);
                if (el) {
                    // simple fadeIn replacement: make visible
                    el.style.display = '';
                    el.classList.add('active');
                }
                var sel = document.getElementById('selectedTab'); if (sel) sel.value = activeTabID;
            }

            //SetSearchLink();
            return false;
        });
    });

    // change handlers for search controls
    document.querySelectorAll('.me-search-types, .me-search-attendees').forEach(function (el) {
        el.addEventListener('change', function () {
            MeetingEventsSyncClear();
            //SetSearchLink();
        });
    });

    // other initialisation can go here
});

function ClosePopup() {
    document.querySelectorAll('.me-popup').forEach(function (el) { el.classList.remove('active'); });
    var inner = document.querySelector('.me-popup-inner'); if (inner) inner.innerHTML = '';
}

function SetSelectedTab() {
    var selectedInput = document.getElementById('selectedTab');
    if (!selectedInput) return;
    var selectedTab = selectedInput.value;
    if (selectedTab !== '') {
        document.querySelectorAll('ul.me-destination-tabs li').forEach(function (li) { li.classList.remove('active'); });
        var link = document.querySelector('ul.me-destination-tabs li a[href="#' + selectedTab + '"]');
        if (link && link.parentElement) link.parentElement.classList.add('active');
        document.querySelectorAll('.mel-destination').forEach(function (d) { d.style.display = 'none'; d.classList.remove('active'); });
        var el = document.getElementById(selectedTab);
        if (el) el.style.display = '';
    }
}

function MeetingEventsSyncClear() {
    var showClear = false;

    // If any of the search controls have a value, show clear
    var types = document.querySelectorAll('.me-search-types');
    types.forEach(function (t) { if (t && t.value && t.value.length > 0) showClear = true; });

    var attendees = document.querySelectorAll('.me-search-attendees');
    attendees.forEach(function (a) { if (a && a.value && a.value.length > 0) showClear = true; });

    document.querySelectorAll('.me-clear-search').forEach(function (el) { el.style.display = showClear ? '' : 'none'; });

    //SetSearchLink();
}

function SetSearchLink() {
    var btn = document.querySelector('.me-search-btn');
    if (!btn) return;
    var searchURL = btn.dataset && btn.dataset.currentUrl ? btn.dataset.currentUrl : '';

    var types = document.querySelector('.me-search-types');
    var attendees = document.querySelector('.me-search-attendees');
    var selectedInput = document.getElementById('selectedTab');

    if (types && types.value) searchURL += types.value + '/';
    if (attendees && attendees.value) searchURL += attendees.value + '/';
    if (selectedInput && selectedInput.value) searchURL += selectedInput.value + '/';

    btn.setAttribute('href', searchURL);
}


